@if (getLayoutType(getFilter(name)) === "RADIO") {
  <div class="top-filter-container mb-2 pb-2">
    @for (option of getFilter(name)?.options; track option) {
      <div [ngClass]="labelToClass(option)" class="radio-input">
        <input
          type="radio"
          [(ngModel)]="getFilter(name).value"
          (ngModelChange)="onFilterValueChange(getFilter(name))"
          (click)="getFilter(name).value = option"
          [name]="getFilter(name).literalId"
          [value]="option"
          [checked]="getFilter(name).value === option"
          [id]="labelToClass(option)" />
        <label [for]="labelToClass(option)">{{ option }}</label>
      </div>
    }
  </div>
  @if (getFilter(name).associatedFilters) {
    <div class="associatedFilter">
      @for (
        associatedFilter of getFilter(name).associatedFilters[
          getFilter(name).value
        ];
        track associatedFilter
      ) {
        @if (getFilter(associatedFilter.associatedFilterLiteralId)) {
          <portal-app-filter-set-radio-popup
            [name]="associatedFilter?.associatedFilterLiteralId"
            [dashboardId]="dashboardId"
            [fieldDefinitions]="fieldDefinitions"
            (filterChange)="onFilterValueChange($event)"
            [filterSet]="filterSet">
          </portal-app-filter-set-radio-popup>
        }
      }
    </div>
  }
}

@if (getLayoutType(getFilter(name)) === "SELECT_WITH_TEXTBOX") {
  <p-select
    [(ngModel)]="getFilter(name).value"
    class="select-input"
    (ngModelChange)="onFilterValueChange(getFilter(name))"
    [options]="getFilter(name).options"
    [showClear]="false"
    [filter]="false"
    [baseZIndex]="2"
    (onHide)="updateContext(idx, getFilter(name).literalId)"
    scrollHeight="24rem"
    appendTo="body"
    [placeholder]="getFilter(name).label">
  </p-select>
  @for (
    associatedFilter of getFilter(name).associatedFilters[
      getFilter(name).value
    ];
    track associatedFilter
  ) {
    @if (getFilter(associatedFilter.associatedFilterLiteralId)) {
      <portal-app-filter-set-radio-popup
        [name]="associatedFilter?.associatedFilterLiteralId"
        [dashboardId]="dashboardId"
        (filterChange)="onFilterValueChange($event)"
        [fieldDefinitions]="fieldDefinitions"
        [filterSet]="filterSet">
      </portal-app-filter-set-radio-popup>
    }
  }
}
@if (getLayoutType(getFilter(name)) === "SELECT") {
  <p-select
    [(ngModel)]="getFilter(name).value"
    (ngModelChange)="onFilterValueChange(getFilter(name))"
    [options]="getFilter(name).options"
    [showClear]="false"
    [filter]="false"
    [baseZIndex]="2"
    (onHide)="updateContext(idx, getFilter(name).literalId)"
    scrollHeight="24rem"
    appendTo="body"
    [placeholder]="getFilter(name).label">
  </p-select>
}
@if (getLayoutType(getFilter(name)) === "INPUT_NUMBER") {
  <p-inputNumber
    type="number"
    class="target-input"
    [ngClass]="name"
    [(ngModel)]="getFilter(name).value"
    [minFractionDigits]="getMinDigits(getFilter(name))"
    (ngModelChange)="onFilterValueChange(getFilter(name))"></p-inputNumber>
}
